







import { Component, Vue, Watch } from 'vue-property-decorator';
import dashjs from 'dashjs';


@Component({
  name: 'Live'
})
export default class Live extends Vue {
  mounted(){
    const ip = process.env.VUE_APP_IP;
    const port = process.env.VUE_APP_PORT;
    const url = `http://${ip}:${port}/live/workstream/index.mpd`;
    const player = dashjs.MediaPlayer().create();
    const el = document.querySelector('#videoPlayer') as HTMLElement;

    player.initialize(el, url);
  }
}
